import { useStore } from '../lib/store.js';

// ArchivistBeat renders a visual indicator of archivist activity.
//
// JOBE-0143.5: `events` is now the live EventSource event array from
// useThreadArchivistEvents (not the full WS event stream). When the
// archivist has emitted at least one event within the past 30 seconds
// the indicator gains the `archivist-beat--active` modifier class
// which CSS animates as a heartbeat pulse.
//
// The `archMode` pref from chatPrefs (JOBE-0135) is applied as a
// second modifier so callers can suppress the animation in 'subtle' mode.
export function ArchivistBeat({ events = [] }) {
  const archMode = useStore(s => s.chatPrefs?.archMode || 'subtle');

  const lastEvent = events.at(-1);
  const lastEventAt = lastEvent?.timestamp ?? null;
  const isRecent = lastEventAt !== null &&
    (Date.now() - new Date(lastEventAt).getTime()) < 30_000;

  // In the stub phase (no archivist JetStream subject), events will always
  // be empty, so isRecent is always false. When events do arrive the pulse
  // activates automatically.
  const hasArchivist = events.length > 0;
  if (!hasArchivist) return null;

  const classes = [
    'archivist-beat',
    isRecent ? 'archivist-beat--active' : '',
    `archivist-beat--${archMode}`,
  ].filter(Boolean).join(' ');

  return (
    <span
      className={classes}
      data-testid="archivist-beat"
      title={isRecent ? 'Archivist active' : 'Archivist silent'}
    >
      ◉
    </span>
  );
}
